// extracted by mini-css-extract-plugin
module.exports = {"count":"BrowserFooter_count__1gZeo","container":"BrowserFooter_container__1LQXY"};